import env from "../utils/helpers/functions/env";

const conf = { 
    siteUrl     : env('REACT_APP_PUBLICSITE'),   
    apiAdmin    : env('REACT_APP_APIURL'),       
    dataServer  : env('REACT_APP_DATA'),         
    googleId    : env('REACT_APP_GOOGLE_ID'),
    defOptimizioWidth : 1500,

    defLofin    : env('REACT_APP_DEF_LOGIN'),
    defPass     : env('REACT_APP_DEF_PASS'),
} 

export default conf; 